// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".d-tabs[data-v-64557104]{align-items:center;display:flex}", "",{"version":3,"sources":["webpack://./resources/js/Components/Common/DTabs.vue"],"names":[],"mappings":"AACA,yBAEI,kBAAA,CADA,YACJ","sourcesContent":["\n.d-tabs {\n    display: flex;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
